import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parentContainer: {
        width: '100%',
        height: '100%',
        padding: 0,
        flexGrow: 1,
        boxSizing: 'border-box',
        margin: 0
    },
    checklistQuestionDataGrid: {
        height: '100%'
    },
    moveIcon: {
        cursor: 'pointer'
    }
});
